import { useEffect, useState } from "react";

const EVENT_NAME = "cardora:feedback";

export const showFeedback = (message, type = "success") => {
  if (!message || typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { message, type } }));
};

export const useFeedbackMessage = (message, type = "success") => {
  useEffect(() => {
    if (message) showFeedback(message, typeof type === "function" ? type(message) : type);
  }, [message, type]);
};

function FeedbackHub() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const receive = event => {
      const message = String(event.detail?.message || "").trim();
      if (!message) return;
      const id = Date.now() + Math.random();
      setItems(current => [...current.filter(item => item.message !== message), { id, message, type: event.detail?.type || "success" }].slice(-3));
      window.setTimeout(() => setItems(current => current.filter(item => item.id !== id)), 4200);
    };
    window.addEventListener(EVENT_NAME, receive);
    return () => window.removeEventListener(EVENT_NAME, receive);
  }, []);

  return (
    <div className="cardora-feedback-hub" aria-live="polite" aria-atomic="false">
      {items.map(item => (
        <div className={`cardora-feedback is-${item.type}`} role={item.type === "danger" ? "alert" : "status"} key={item.id}>
          <i className={`bi ${item.type === "danger" ? "bi-exclamation-circle-fill" : item.type === "warning" ? "bi-exclamation-triangle-fill" : "bi-check-circle-fill"}`} />
          <span>{item.message}</span>
          <button type="button" onClick={() => setItems(current => current.filter(entry => entry.id !== item.id))} aria-label="Cerrar aviso"><i className="bi bi-x-lg" /></button>
        </div>
      ))}
    </div>
  );
}

export default FeedbackHub;
